/* eslint-disable filenames-simple/naming-convention */
import React from 'react';

import FourOhFour from '../components/FourOhFour';

function FourOhFourPage(): JSX.Element {
  return <FourOhFour />;
}

FourOhFourPage.displayName = 'FourOhFourPage';

export default FourOhFourPage;
